export default __webpack_public_path__ + "static/media/happy(100).49e0a065.gif";